import { IssuecanvasComponent } from '@solar/solar/supervis/issuecanvas/issuecanvas.component';
import { fabric } from 'fabric';

/**
 * Canvas filters
 */
export class CanvasFilter {

    public canvas: IssuecanvasComponent;

    public filterStatus = { grayscale: false, invert: false };

    filters = ['grayscale', 'invert', 'remove-color', 'sepia', 'brownie',
    'brightness', 'contrast', 'saturation', 'noise', 'vintage',
    'pixelate', 'blur', 'sharpen', 'emboss', 'technicolor',
    'polaroid', 'blend-color', 'gamma', 'kodachrome',
    'blackwhite', 'blend-image', 'hue', 'resize'];

    constructor(canvas:IssuecanvasComponent) {
        this.canvas = canvas;
    }

    filterBtnToggle($event) {
        let btn = $event.currentTarget;
        btn.classList.toggle("btn-outline-secondary");
        btn.classList.toggle("btn-secondary");
    }

    applyFilter(obj, index, filter) {
        let canvas = this.canvas.fabcanvas;

        obj.filters[index] = filter;
        obj.applyFilters();

        //canvas.renderAll.bind(canvas);
        canvas.requestRenderAll();
    }


    filtergrayscale($event) {
        this.filterBtnToggle($event);

        let img = this.canvas.backGroundImgObject;
        this.filterStatus.grayscale = !this.filterStatus.grayscale;
        this.applyFilter(img, 0, this.filterStatus.grayscale && new fabric.Image.filters.Grayscale());
    }



    filterInvert($event) {
        this.filterBtnToggle($event);
        let img = this.canvas.backGroundImgObject;
        this.filterStatus.invert = !this.filterStatus.invert;
        this.applyFilter(img, 1, this.filterStatus.invert && new fabric.Image.filters.Invert());
    }

    applySelectedFiltersToImageBackground(){
        let obj=this.canvas.backGroundImgObject;
        if (this.filterStatus.grayscale){
          this.applyFilter(obj,0, new fabric.Image.filters.Grayscale());
        }
        if (this.filterStatus.invert){
          this.applyFilter(obj,1, new fabric.Image.filters.Invert());
        }   
        obj.applyFilters();
        this.canvas.fabcanvas.requestRenderAll();
      }
}